import { render, staticRenderFns } from "./CustomerCrmIndex.vue?vue&type=template&id=a46306de&scoped=true"
import script from "./CustomerCrmIndex.vue?vue&type=script&lang=js"
export * from "./CustomerCrmIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46306de",
  null
  
)

export default component.exports